<template>
  <div class="view-workout-history px-4 px-lg-5 text-light py-5">
    <router-link
      :to="{ name: 'workout' }"
      class="text-secondary small text-decoration-none"
    >
      <i class="fas fa-chevron-left" /> Seja forte
    </router-link>

    <h5>Exercícios</h5>

    <action-dispatcher
      action="workout/getHistory"
      class="container mt-4"
      ref="historyGet"
      :parameters="params"
      :always-show-slot="!firstLoad"
      @success="firstLoad = false"
    >
      <div class="card mb-3" v-for="item in history" :key="item.id">
        <button class="card-header" @click="clickCollapse(item)">
          <img
            v-if="item.data.training.image"
            :src="item.data.training.image"
          />
          <div class="d-flex flex-column flex-fill">
            <strong>{{ item.data.training.title }}</strong>
            <small class="text-secondary">{{ date(item) }}</small>
          </div>
          <i
            class="fas text-secondary"
            :class="{
              'fa-chevron-down': collapse !== item.id,
              'fa-chevron-up': collapse === item.id
            }"
          />
        </button>

        <b-collapse
          :visible="collapse === item.id"
          accordion="my-accordion"
          role="tabpanel"
        >
          <div
            class="card-body"
            v-for="exercise in item.data.exercises"
            :key="`${item.id} ${exercise.id}`"
          >
            <strong class="text-secondary d-block mb-2">
              {{ exercise.title }}
            </strong>
            <div class="d-flex align-items-center mx-n4">
              <div
                v-for="(serie, index) in exercise.series"
                :key="`${item.id} ${exercise.id} ${index}`"
                class="mx-4"
              >
                <span class="circle"> 0{{ index + 1 }} </span>
                <span class="mx-2">
                  {{ serie.weight ? serie.weight : 0 }}kg
                </span>
                <span> {{ serie.repetitions }} reps </span>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </action-dispatcher>

    <div v-if="count > history.length" class="text-center pt-4">
      <button class="btn btn-load-more rounded-pill" @click="loadMore">
        VER MAIS
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      collapse: null,
      firstLoad: true,
      params: {
        offset: 0,
        limit: 10
      }
    };
  },
  computed: {
    ...mapState("workout", ["history", "count"])
  },
  mounted() {
    this.$store.commit("workout/setHistory", []);
  },
  methods: {
    clickCollapse(item) {
      if (this.collapse === item.id) {
        this.collapse = null;
      } else {
        this.collapse = item.id;
      }
    },
    date(item) {
      return new Date(item.created_at).toLocaleDateString();
    },
    loadMore() {
      this.params.offset += this.params.limit;
      setTimeout(() => {
        this.$refs.historyGet.dispatch();
      }, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.view-workout-history {
  .card {
    background: #1c1c1c;
    border-radius: 5px;

    .card-header {
      border: none;
      padding: 8px;
      display: flex;
      align-items: center;
      color: white;
      text-align: left;

      img {
        width: 74px;
        height: 66px;
        margin-right: 8px;
        object-fit: cover;
      }
    }

    .card-body {
      padding: 8px 16px;

      &:nth-child(odd) {
        background: rgba(0, 0, 0, 0.2);
      }

      .circle {
        width: 21px;
        height: 21px;
        background: #787878;
        border-radius: 130px;
        display: inline-flex;
        color: black;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }

  .btn-load-more {
    font-size: 14px;
    line-height: 21px;
    padding: 10px 32px;
    font-weight: 500;
    background: #1c1c1c;
    color: white;

    &:hover {
      background: #191919;
    }
  }
}
</style>
